import { BaseCall } from '../BaseCall'
import { APIConfig } from '../interfaces'

export class Translator extends BaseCall {
	public apply = async (fileName: string, userId: string): Promise<{ domain: string }> => {
		const response = await this.client.post<{ domain: string }>('/translator', {
			fileName,
			userId
		})
		return response.data
	}

	public delete = async (fileName: string): Promise<void> => {
		await this.client.post('/translator/delete', {
			fileName
		})
	}

	public setConfig(config: APIConfig): void {
		this.setBaseUrl(config.API_SERVER)
	}
}
